// extracted by mini-css-extract-plugin
export default {"header":"applications-components-HeaderApp-components-HeaderWrapper-header-wrapper-module__header"};
    if(module.hot) {
      // 1707476361721
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  